
<div class="training-container">
  <div class="training-card">

    <div class="loader-area">
      <div class="spinner"></div>
      <img src="assets/images/ai_doc.gif" class="ai-gif" alt="AI Training">
    </div>

    <h2 class="title">
      AI Training in Progress
    </h2>

    <p class="subtitle">
      We are processing your uploaded document and preparing the AI
      to answer questions based on its content.
    </p>

    <div class="progress-dots">
      <span></span>
      <span></span>
      <span></span>
    </div>

  </div>
</div>
